import z from 'zod';

import { EntitySchema, UserRole, UserRoleEnum } from '../primitives';

export const UserSchema = EntitySchema.extend({
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    iocCountryCode: z.string().nullish(),
    profilePictureImageId: z.string().nullish(),
    organisation: z.string().nullish(),
    memo: z.string().nullish(),
    roles: z.array(UserRoleEnum),
    password: z.string().optional(),
});

export const UserSlimSchema = EntitySchema.extend({
    name: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    iocCountryCode: z.string().nullish(),
    profilePictureImageId: z.string().nullish(),
    organisation: z.string().nullish(),
});

export const createDefaultUser = (): User => {
    return {
        id: '',
        firstName: '',
        lastName: '',
        email: '',
        iocCountryCode: null,
        profilePictureImageId: null,
        organisation: null,
        memo: null,
        roles: [UserRole.User],
        password: undefined,
    };
};

export type User = z.infer<typeof UserSchema>;

export type UserSlim = z.infer<typeof UserSlimSchema>;
